export default __webpack_public_path__ + "static/media/v-icon.9aeda760.png";